(() => {
  class InsuranceComparisonCalculator extends HTMLElement {
    constructor() {
      super();
      this.cleanup = [];
    }

    connectedCallback() {
      if (this.dataset.initialized === "true") return;

      this.dataset.initialized = "true";

      const root = this;
      const cleanup = this.cleanup;

      var CUR={AUD:"$",USD:"$",GBP:"£",NZD:"$",CAD:"$",EUR:"€"};
        var COLORS=["#0e7c7b","#ff6b5c","#f2a900","#5b7cc2"];
        var period="month";
        var MAXP=4;
      
        var policies=[
          {label:"Policy A", premium:55, excess:200, rate:80, limit:12000},
          {label:"Policy B", premium:78, excess:100, rate:90, limit:25000}
        ];
      
        var $=function(id){return root.querySelector('[data-id="'+id+'"]');};
        var gnum=function(id){var v=parseFloat($(id).value);return isNaN(v)?0:v;};
        function sym(){return CUR[$("cur").value];}
        function fmt(v){var neg=v<0;v=Math.abs(Math.round(v));return (neg?"−":"")+sym()+v.toLocaleString("en-US");}
        function pct(v){return Math.round(v)+"%";}
      
        function setPeriod(p){period=p;$("pMonth").classList.toggle("on",p==="month");$("pYear").classList.toggle("on",p==="year");renderInputs();calc();};
      
        function reimb(cost,excess,rate,limit){var e=Math.max(0,cost-excess);var p=e*rate;if(limit>0)p=Math.min(p,limit);return p;}
      
        function letter(i){return String.fromCharCode(65+i);}
      
        function renderInputs(){
          var host=$("policies");host.innerHTML="";
          policies.forEach(function(p,i){
            var c=COLORS[i%COLORS.length];
            var div=document.createElement("div");
            div.className="pcard";
            div.innerHTML=
              '<div class="ptop"><span class="pchip" style="background:'+c+'">'+letter(i)+'</span>'+
                '<input class="plabel" type="text" data-i="'+i+'" data-f="label" value="'+escapeAttr(p.label)+'" maxlength="26"></div>'+
              (policies.length>2?'<button class="rm" type="button" title="Remove" data-remove-policy="'+i+'">&times;</button>':'')+
              '<div class="pf"><label>Premium ('+period+')</label><div class="in"><span class="pre cursym">'+sym()+'</span>'+
                '<input class="cur" type="number" data-i="'+i+'" data-f="premium" value="'+p.premium+'" min="0" step="1"></div></div>'+
              '<div class="prow">'+
                '<div class="pf"><label>Excess</label><div class="in"><span class="pre cursym">'+sym()+'</span>'+
                  '<input class="cur" type="number" data-i="'+i+'" data-f="excess" value="'+p.excess+'" min="0" step="10"></div></div>'+
                '<div class="pf"><label>Reimburse</label><div class="in">'+
                  '<input class="pct" type="number" data-i="'+i+'" data-f="rate" value="'+p.rate+'" min="1" max="100" step="5"><span class="post">%</span></div></div>'+
              '</div>'+
              '<div class="pf"><label>Annual payout limit</label><div class="in"><span class="pre cursym">'+sym()+'</span>'+
                '<input class="cur" type="number" data-i="'+i+'" data-f="limit" value="'+p.limit+'" min="0" step="500"></div></div>';
            host.appendChild(div);
          });
          $("addBtn").disabled = policies.length>=MAXP;
        }
        function escapeAttr(s){return (s+"").replace(/"/g,"&quot;").replace(/</g,"&lt;").replace(/>/g,"&gt;");}
      
        function addPolicy(){
          if(policies.length>=MAXP)return;
          var i=policies.length;
          policies.push({label:"Policy "+letter(i), premium:60, excess:150, rate:80, limit:15000});
          renderInputs();calc();
        };
        function removePolicy(i){
          if(policies.length<=2)return;
          policies.splice(i,1);renderInputs();calc();
        };
      
        // delegated input handling (keeps focus)
        $("policies").addEventListener("input",function(e){
          var t=e.target;if(t.dataset.i===undefined)return;
          var i=+t.dataset.i, f=t.dataset.f;
          policies[i][f]= f==="label"? t.value : (parseFloat(t.value)||0);
          calc();
        });
      
        function compute(p){
          var annual = period==="month"? p.premium*12 : p.premium;
          var rate = Math.min(100,Math.max(0,p.rate))/100;
          var exp=gnum("expected"), emg=gnum("emergency");
          var be = rate>0 ? annual/rate + p.excess : Infinity;
          var payTyp = reimb(exp,p.excess,rate,p.limit);
          var oopTyp = annual + (exp - payTyp);          // total you bear in a typical year
          var payEmg = reimb(emg,p.excess,rate,p.limit);
          var oopEmg = annual + (emg - payEmg);          // total you bear in a bad year
          var covEmg = emg>0 ? payEmg/emg*100 : 0;
      
          // multi-year cumulative out-of-pocket (typical costs, inflating)
          var yrs=Math.max(1,Math.round(gnum("years")));
          var pg=gnum("premGrow")/100, cg=gnum("costGrow")/100;
          var cumOop=0;
          for(var y=0;y<yrs;y++){
            var pr=annual*Math.pow(1+pg,y);
            var co=exp*Math.pow(1+cg,y);
            cumOop += pr + (co - reimb(co,p.excess,rate,p.limit));
          }
          return {annual:annual, be:be, oopTyp:oopTyp, oopEmg:oopEmg, covEmg:covEmg, cumOop:cumOop, payEmg:payEmg};
        }
      
        function calc(){
          // refresh currency symbols
          var s=sym();
          Array.prototype.forEach.call(root.getElementsByClassName("cursym"),function(el){el.textContent=s;});
          $("emgLabel").textContent=fmt(gnum("emergency"));
      
          var R=policies.map(compute);
      
          // lowest/highest index per metric — purely arithmetic, marks the extreme value only (not a recommendation)
          function minIdx(key){var bi=0,bv=Infinity;R.forEach(function(r,i){if(r[key]<bv){bv=r[key];bi=i;}});return {i:bi,v:bv};}
          function maxIdx(key){var bi=0,bv=-Infinity;R.forEach(function(r,i){if(r[key]>bv){bv=r[key];bi=i;}});return {i:bi,v:bv};}
          // only mark an extreme when the values actually differ, so identical columns aren't singled out
          function allSame(key){var f=R[0][key];return R.every(function(r){return r[key]===f;});}
          var loPrem=minIdx("annual"), loTyp=minIdx("oopTyp"), loEmg=minIdx("oopEmg"),
              loCum=minIdx("cumOop"), hiCov=maxIdx("covEmg");
      
          var yrs=Math.max(1,Math.round(gnum("years")));
          var rows=[
            {label:"Annual premium", sub:"What you pay the insurer", key:"annual", mark:allSame("annual")?null:loPrem.i, tag:"lowest", fmt:fmt},
            {label:"Break-even vet bill", sub:"Claims needed before the premiums are returned", key:"be", mark:null, tag:"", fmt:function(v){return v===Infinity?"—":fmt(v);}},
            {label:"Cost in a typical year", sub:"Premiums + your unreimbursed share", key:"oopTyp", mark:allSame("oopTyp")?null:loTyp.i, tag:"lowest", fmt:fmt},
            {label:"Cost in a bad year", sub:"Total out-of-pocket if the emergency hits", key:"oopEmg", mark:allSame("oopEmg")?null:loEmg.i, tag:"lowest", fmt:fmt},
            {label:"Emergency covered", sub:"Share of the big bill paid back", key:"covEmg", mark:allSame("covEmg")?null:hiCov.i, tag:"highest", fmt:pct},
            {label:yrs+"-year total cost", sub:"Cumulative, with premium + cost rises", key:"cumOop", mark:allSame("cumOop")?null:loCum.i, tag:"lowest", fmt:fmt}
          ];
      
          // header
          var thead="<tr><th class='metric'>Metric</th>";
          policies.forEach(function(p,i){
            thead+="<th><span class='thchip'><span class='pchip' style='width:18px;height:18px;border-radius:5px;background:"+COLORS[i%COLORS.length]+"'>"+letter(i)+"</span>"+escapeAttr(p.label)+"</span></th>";
          });
          thead+="</tr>";
          $("resTable").tHead.innerHTML=thead;
      
          var tb="";
          rows.forEach(function(row){
            tb+="<tr><td class='metric'><div class='mlabel'>"+row.label+"</div><div class='msub'>"+row.sub+"</div></td>";
            R.forEach(function(r,i){
              var isMark=(row.mark!==null && row.mark===i && policies.length>1);
              tb+="<td class='val"+(isMark?" best":"")+"'>"+row.fmt(r[row.key])+(isMark?"<span class='tick'>"+row.tag+"</span>":"")+"</td>";
            });
            tb+="</tr>";
          });
          $("resTable").tBodies[0].innerHTML=tb;
      
          $("bestNote").textContent = policies.length>1 ? "Highlight = lowest cost / highest cover on your figures" : "";
      
          // protection bars (out-of-pocket in bad year; scale to max)
          var maxOop=Math.max.apply(null,R.map(function(r){return r.oopEmg;}).concat([1]));
          var bars="";
          var loEmgIdx = allSame("oopEmg") ? -1 : loEmg.i;
          R.forEach(function(r,i){
            var w=Math.max(4, r.oopEmg/maxOop*100);
            var isLow=(loEmgIdx===i && policies.length>1);
            bars+="<div class='bar-row'>"+
              "<div class='bar-name'><span class='pchip' style='width:18px;height:18px;border-radius:5px;background:"+COLORS[i%COLORS.length]+"'>"+letter(i)+"</span>"+escapeAttr(policies[i].label)+"</div>"+
              "<div class='bar-track'><div class='bar-fill' style='width:"+w.toFixed(1)+"%;background:"+COLORS[i%COLORS.length]+(isLow?"":";opacity:.75")+"'></div></div>"+
              "<div class='bar-val'>"+fmt(r.oopEmg)+"</div></div>";
          });
          $("protBars").innerHTML=bars;
        }
      
        // caveats checklist
        var CHECKS=[
          ["Pre-existing conditions","Anything your pet has shown signs of before cover starts is usually excluded — often permanently."],
          ["Waiting periods","Cover for illness, and especially cruciate/knee and some conditions, may not start for days to months."],
          ["Per-condition & sub-limits","A high annual limit can still hide low caps per condition, per body part, or on specific treatments."],
          ["Bilateral condition rules","If one hip, knee or eye is claimed, the other side may be treated as pre-existing."],
          ["What counts as claimable","Dental, behaviour, alternative therapy, exam fees, prescription food and preventives are often limited or excluded."],
          ["Age & renewal loadings","Premiums rise with age; some policies won't take on, or keep covering, older pets for new conditions."],
          ["Excess type","An annual excess and a per-condition excess produce very different real costs — check which applies."],
          ["Claim experience","Payout speed, cashless options at the vet, and how disputes are handled matter as much as the price."]
        ];
        function renderChecks(){
          var h="";
          CHECKS.forEach(function(c){
            h+="<div class='chk'><svg class='ci' viewBox='0 0 20 20' fill='none'><path d='M10 2l7 3v5c0 4-3 6.5-7 8-4-1.5-7-4-7-8V5l7-3z' stroke='#f2a900' stroke-width='1.4' fill='#fff8ec'/></svg>"+
              "<div><b>"+c[0]+"</b> — "+c[1]+"</div></div>";
          });
          $("checks").innerHTML=h;
        }
      
        function listen(target,event,handler){
          target.addEventListener(event,handler);
          cleanup.push(function(){target.removeEventListener(event,handler);});
        }
      
        ["cur","expected","emergency","years","premGrow","costGrow"].forEach(function(id){
          listen($(id),"input",calc);
          listen($(id),"change",calc);
        });
      
        listen($("cur"),"change",renderInputs);
        listen($("pMonth"),"click",function(){setPeriod("month");});
        listen($("pYear"),"click",function(){setPeriod("year");});
        listen($("addBtn"),"click",addPolicy);
      
        listen($("policies"),"click",function(event){
          var button=event.target.closest("[data-remove-policy]");
          if(!button || !root.contains(button))return;
          removePolicy(Number(button.getAttribute("data-remove-policy")));
        });
      
        renderInputs();
        renderChecks();
        calc();
    }

    disconnectedCallback() {
      this.cleanup.forEach((removeListener) => removeListener());
      this.cleanup = [];
      delete this.dataset.initialized;
    }
  }

  if (!customElements.get("s-insurance-comparison-calculator")) {
    customElements.define(
      "s-insurance-comparison-calculator",
      InsuranceComparisonCalculator
    );
  }
})();
